<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Partners Telegram Campaigns'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                variant="success"
                class="button"
                @click="() => showModal()"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilters"
          />
          <TableForPage
            ref="table"
            :tableData="getTableData"
            :fields="getTableFields"
            :slots="getTableSlots"
            :perPage="getPartnerTelegramCampaigns.per_page"
            :currentPage="getPartnerTelegramCampaigns.current_page"
            :totalRows="getPartnerTelegramCampaigns.total"
            :actions="getTableActions"
            isServerRender
            noLocalSorting
            @remove="remove"
            @edit="showModal"
            @start="start"
            @update="updateList"
          >
            <template v-slot:partners="data">
              <span v-if="data.item.for_all">For All</span>
              <span v-else-if="data.item.partners.length === 0">Selected telegram was removed</span>
              <div v-else v-for="telegram in data.item.partners" v-bind:key="telegram.id">
                <span :key="telegram.id">{{ telegram.partner.company_name }}</span>
              </div>
            </template>
          </TableForPage>
        </div>
      </div>
    </div>

    <PartnerTelegramCampaignModal
      v-model="modal.show"
      :form="modal.form"
      @save="save"
    />
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import TelegramPartnersCampaignMixin from '@mixins/notifications/TelegramPartnersCampaignMixin'
import PartnerTelegramCampaignModal from '@components/modals/Telegram/PartnerTelegramCampaignModal'

export default {
  mixins: [TelegramPartnersCampaignMixin],
  components: {
    PageHeader,
    PartnerTelegramCampaignModal,
    Filters,
    TableForPage
  },
  data () {
    return {}
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getAvailablePartnerTelegrams: 'telegram/getAvailablePartnerTelegrams',
      getPartnerTelegramCampaigns: 'telegram/getPartnerTelegramCampaigns'
    }),
    getTableFilters () {
      return this.filters || {}
    },
    getTableFields () {
      return this.table.fields || []
    },
    getTableSlots () {
      return this.table.slots || []
    },
    getTableActions () {
      return this.table.actions || []
    },
    getTableData () {
      return this.getPartnerTelegramCampaigns.data || []
    }
  },
  methods: {
    fetchAllData () {
      return Promise.all([
        this.fetchAvailablePartners(),
        this.fetchList()
      ]).then(() => {
        this.setAllOptions()
      })
    },
    setAllOptions () {
      this.modal.form.partners.options = this.getAvailablePartnerTelegrams
    },
    fetchAvailablePartners () {
      return this.$api.telegram.getAvailablePartnerTelegrams()
    },
    fetchList () {
      let params = this.table.params.currentPage
      if (this.table.params.sorting) {
        params += this.table.params.sorting
      }
      if (this.table.params.filters) {
        params += this.table.params.filters
      }
      return this._toggleDataPageLoading(() => this.$api.telegram.getPartnerTelegramCampaigns(params))
    },
    updateList (data) {
      if (!data) return this.fetchList()

      const { currentPage, sortDesc, sortBy } = data
      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)
      this.fetchList()
    },
    setFilters (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchList()
    },
    save (data) {
      const campaign = this.prepareDataForRequest(data)
      const requestPromise = this.modal.campaignId
        ? this.$api.telegram.editPartnerTelegramCampaign({ id: this.modal.campaignId, ...campaign })
        : this.$api.telegram.createPartnerTelegramCampaign(campaign)
      requestPromise.then(() => {
        this.$snotify.success('Partner telegram campaign successfully saved', 'Success', this.$store.state.snotify)
        this.hideModal()
        this.fetchList()
      }).catch(err => {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    async start (item) {
      const confirm = await this.$root.$confirm.open(
        'Start',
        'Are you sure you want to start the partner telegram campaign?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const startResponse = await this.$api.telegram.startPartnerTelegramCampaign(item.id)
        this.$snotify.success(
          startResponse.data,
          'Success',
          this.$store.state.snotify
        )
      })
    },
    async remove (item) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the partner telegram campaign?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.telegram.removePartnerTelegramCampaign(item.id)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updateList()
      })
    }
  }
}
</script>

<style>

</style>
